import ButtonsHeader from "../components/common/ButtonsHeader";
import WalletPageSkeleton from "../components/common/skeletons/WalletSkeleton";
import { useGetWalletContextsQuery } from "@/lib/api/apiSlice";
import { useShowInitialLoader } from "@/lib/hooks";
import WalletView from "./WalletView";

export default function WalletPage() {
  const { data: walletContexts, isLoading } = useGetWalletContextsQuery();
  const showLoader = useShowInitialLoader(isLoading, walletContexts);

  if (showLoader) {
    return (
      <div className="min-h-screen">
        <ButtonsHeader heading="My Wallet" showButtons={false} />
        <WalletPageSkeleton />
      </div>
    );
  }

  return (
    <div className="min-h-screen">
      <ButtonsHeader heading="My Wallet" showButtons={false} />
      <WalletView walletContexts={walletContexts ?? null} />
    </div>
  );
}
